const mileStatics = [
  {
    name: "1 PM",
    mileStats: 6000,
  },
  {
    name: "2 PM",
    mileStats: 5000,
  },
  {
    name: "3 PM",
    mileStats: 7000,
  },
  {
    name: "4 PM",
    mileStats: 5780,
  },
  {
    name: "5 PM",
    mileStats: 4890,
  },
  {
    name: "6 PM",
    mileStats: 6390,
  },
  {
    name: "7 PM",
    mileStats: 5490,
  },
];

export default mileStatics;
